import type { ReactElement } from "react";
import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material";
import { BooleanField, Datagrid, FunctionField, TextField, useListContext } from "react-admin";
import { useNavigate } from "react-router";
import { MoneyField } from "../../fields/MoneyField";
import { Column } from "../../misc/Column";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import type { SubscriptionPackage } from "../../providers/subscriptionPackagesProvider";
import { SubscriptionPackageMobileListItem } from "./SubscriptionPackageMobileListItem";

export function SubscriptionPackagesDataGrid(props: { empty?: ReactElement }) {
  const { empty } = props;
  const { isLoading, data, total } = useListContext<SubscriptionPackage>();
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isMobile) {
    if (!data || data.length === 0 || total === 0) {
      return empty ?? null;
    }

    return (
      <Column sx={{ gap: 1, py: "1px" }}>
        {data.map((subscriptionPackage) => (
          <SubscriptionPackageMobileListItem
            key={subscriptionPackage.id}
            subscriptionPackage={subscriptionPackage}
            onClick={() => navigate(`/subscriptionPackages/${subscriptionPackage.id}`)}
          />
        ))}
      </Column>
    );
  }

  return (
    <Datagrid rowClick="edit" bulkActionButtons={false} empty={empty}>
      <TextField label="Name" source="name" />
      <MoneyField label="Preis" source="price" />
      <BooleanField label="Empfohlen" source="recommended" />
      <FunctionField<SubscriptionPackage> label="Merkmale" render={_renderFeatures} sortable={false} />
    </Datagrid>
  );
}

function _renderFeatures(record: SubscriptionPackage): React.ReactNode {
  const { features } = record;
  return features.map((feature, index) => (
    <span key={index}>
      {feature}
      {index < features.length - 1 && <br />}
    </span>
  ));
}
